import { translateDefaultEntity } from "utilities/localesUtilities";
import { useRCAHistoryMainStyles } from "../../RCA.styles";
import { DefaultTranslationFieldsInTable } from "constants/constants";
import { useTranslation } from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { IStatus } from "entities/RCA/StatusEntity/StatusEntityInterfaces";

export const RCAStatusChangeLog = ({ oldStatus, newStatus }: { oldStatus?: IStatus; newStatus?: IStatus }) => {
    const classes = useRCAHistoryMainStyles();
    const { i18n } = useTranslation();

    return (
        <div className={classes.historyChangeWrapper}>
            <span className={classes.historyText}>
                {translateDefaultEntity(i18n.language, oldStatus, "name", DefaultTranslationFieldsInTable.STATUS)}
            </span>
            <ArrowForwardIcon />
            <span className={classes.historyText}>
                {translateDefaultEntity(i18n.language, newStatus, "name", DefaultTranslationFieldsInTable.STATUS)}
            </span>
        </div>
    );
};
